import * as React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { ThemeProvider, createTheme } from "@mui/material/styles";

// helper แปลงวันที่ไทย DD/MM/YYYY(BE) -> Date
const parseThaiDate = (s) => {
  if (!s || typeof s !== "string") return null;
  const [dd, mm, yyyy] = s.split("/");
  const y = Number(yyyy) - 543;
  const m = Number(mm) - 1;
  const d = Number(dd);
  if (Number.isNaN(y) || Number.isNaN(m) || Number.isNaN(d)) return null;
  return new Date(y, m, d);
};

const theme = createTheme({
  components: {
    MuiTableHead: {
      styleOverrides: {
        root: { backgroundColor: "#FFA500" },
      },
    },
  },
});

export default function CollapsibleTable({ data }) {
  // บังคับให้เป็น array เสมอและ copy ก่อน sort
  const rowsSorted = React.useMemo(() => {
    const arr = Array.isArray(data?.loanHistory) ? data.loanHistory : [];
    return [...arr].sort((a, b) => {
      const da = parseThaiDate(a?.loanDate);
      const db = parseThaiDate(b?.loanDate);
      // null ไปท้าย
      if (!da && !db) return 0;
      if (!da) return 1;
      if (!db) return -1;
      return db - da; // ใหม่ -> เก่า
    });
  }, [data?.loanHistory]);

  return (
    <ThemeProvider theme={theme}>
      <TableContainer component={Paper}>
        <Table aria-label="collapsible table">
          <TableHead>
            <TableRow sx={{ "& > *": { p: "5px" }, backgroundColor: "#e7e7e786" }}>
              <TableCell align="center">วันที่กู้เงิน</TableCell>
              <TableCell align="center">จำนวนเงินกู้</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rowsSorted.length === 0 ? (
              <TableRow>
                <TableCell align="center" colSpan={2}>-</TableCell>
              </TableRow>
            ) : (
              rowsSorted.map((item, idx) => (
                <TableRow key={idx} sx={{ "& > *": { p: "5px" } }}>
                  <TableCell align="center">{item?.loanDate ?? "-"}</TableCell>
                  <TableCell align="right">
                    {typeof item?.loanAmount === "number"
                      ? item.loanAmount.toLocaleString(undefined, { minimumFractionDigits: 2 })
                      : "-"}
                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </ThemeProvider>
  );
}
